<template>
  <div style="height: 50px;" @click="onClearStorage"></div>
</template>
<script>
 export default {
   data() {
    return {
      clickCount: 1
    }
  },
  methods: {
    onClearStorage() {
      if (this.clickCount === 1) {
        this.clickCount = 2
        clearTimeout(this.timer)
        this.timer = setTimeout(() => {
          this.clickCount = 1
        }, 300)
      } else if (this.clickCount === 2) {
        clearTimeout(this.timer)
        this.clickCount = 1
        localStorage.removeItem('openId')
        localStorage.removeItem('userAvatar')
        localStorage.removeItem('username')
        localStorage.removeItem('AppId')
        localStorage.removeItem('DomainName')
        this.$toast('缓存清除成功')
      }
    }
  }
 }
</script>
